import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLayout from "./layouts/AdminLayout";
import AreaPage from "./pages/AreaPage";
import ProtectedRoute from "./utils/ProtectedRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";

/* WEBSITE */
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Service from "./pages/Service";
import About from "./pages/About";
import BrandsPage from "./pages/Brand";
import TrackRepair from "./pages/TrackRepair";
import ThankYou from "./pages/Thank-you";
import PrivacyPolicy from "./pages/privacy-policy";
import Terms from "./pages/Trems";
import WashingMachineService from "./pages/WashingMachineService";
import FridgeService from "./pages/FridgeService";
import ACService from "./pages/ACService";
import ACNotCooling from "./pages/ACNotCooling";
import ACGasLeakage from "./pages/ACGasLeakage";
import ACCompressorRepair from "./pages/ACCompressorRepair";
import BrandServicePage from "./pages/BrandServicePage";
import BrandServiceDetailPage from "./pages/BrandServiceDetailPage";
import brandPageData from "./data/brandPageData";
import SingleDoorFridgeService from "./pages/SingleDoorFridgeService";
import DoubleDoorRefrigeratorService from "./pages/DoubleDoorRefrigeratorService";
import SideBySideFridgeService from "./pages/SideBySideFridgeService";
import MiniFridgeService from "./pages/MiniFridgeService";
import FridgeNotCoolingRepair from "./pages/FridgeNotCoolingRepair";
import FridgeGasRefillService from "./pages/FridgeGasRefillService";
import FridgeCompressorRepair from "./pages/FridgeCompressorRepair";
import FridgeNoiseProblem from "./pages/FridgeNoiseProblem";
import FridgeWaterLeakRepair from "./pages/FridgeWaterLeakRepair";
import FridgeIceBuildupRepair from "./pages/FridgeIceBuildupRepair";
import FridgeFreezerCoolingIssue from "./pages/FridgeFreezerCoolingIssue";

/* ADMIN */
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminRegister from "./pages/Admin/AdminRegister";
import AdminServices from "./pages/Admin/AdminServices";
import Brands from "./pages/Admin/Brands";
import Orders from "./pages/Admin/Orders";
import RFQ from "./pages/Admin/RFQ";
import Technicians from "./pages/Admin/Technicians";
import Cutomer from "./pages/Admin/Cutomer";

function SlugRouteHandler() {
  const { slug } = useParams();
  const brandKeys = Object.keys(brandPageData);

  if (slug?.startsWith("appliance-repair-service-in-")) {
    return <AreaPage />;
  }

  const normalized = slug?.trim().toLowerCase();
  const brandKey = normalized?.split("-")[0];
  if (brandKeys.includes(brandKey)) {
    return <BrandServiceDetailPage />;
  }

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <>
      {!isAdminPage && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Service />} />
        <Route path="/about" element={<About />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/track-repair" element={<TrackRepair />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route
          path="/lg-appliance-service-bangalore"
          element={<BrandServicePage brandKey="lg" />}
        />
        <Route
          path="/lg-washing-machine-service-bangalore"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-repair-bangalore"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-not-spinning"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-not-working-repair"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-water-leak-repair"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-no-power-issue"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-noise-problem"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-washing-machine-drum-repair"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-front-load-washing-machine-service-bangalore"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-top-load-washing-machine-service-bangalore"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-fridge-service-bangalore"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-fridge-not-cooling"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-fridge-gas-leakage"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/lg-fridge-compressor-repair"
          element={<BrandServiceDetailPage />}
        />
        <Route
          path="/single-door-fridge-service-bangalore"
          element={<SingleDoorFridgeService />}
        />
        <Route
          path="/double-door-refrigerator-service-bangalore"
          element={<DoubleDoorRefrigeratorService />}
        />
        <Route
          path="/side-by-side-fridge-service-bangalore"
          element={<SideBySideFridgeService />}
        />
        <Route
          path="/mini-fridge-service-bangalore"
          element={<MiniFridgeService />}
        />
        <Route
          path="/fridge-not-cooling-repair"
          element={<FridgeNotCoolingRepair />}
        />
        <Route
          path="/fridge-gas-refill-service-bangalore"
          element={<FridgeGasRefillService />}
        />
        <Route
          path="/fridge-compressor-repair"
          element={<FridgeCompressorRepair />}
        />
        <Route
          path="/fridge-noise-problem"
          element={<FridgeNoiseProblem />}
        />
        <Route          path="/fridge-water-leak-repair"
          element={<FridgeWaterLeakRepair />}
        />
        <Route
          path="/fridge-ice-buildup-repair"
          element={<FridgeIceBuildupRepair />}
        />
        <Route
          path="/freezer-cooling-issue"
          element={<FridgeFreezerCoolingIssue />}
        />
        <Route
          path="/ac-not-cooling"
          element={<ACNotCooling />}
        />
        <Route
          path="/ac-gas-leakage"
          element={<ACGasLeakage />}
        />
        <Route
          path="/ac-compressor-repair"
          element={<ACCompressorRepair />}
        />
        <Route          path="/washing-machine-service-bangalore"
          element={<WashingMachineService />}
        />
        <Route
          path="/fridge-service-bangalore"
          element={<FridgeService />}
        />
        <Route
          path="/ac-service-bangalore"
          element={<ACService />}
        />
        <Route
          path="/samsung-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="samsung" />}
        />
        <Route
          path="/ifb-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="ifb" />}
        />
        <Route
          path="/whirlpool-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="whirlpool" />}
        />
        <Route
          path="/bosch-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="bosch" />}
        />

        <Route
          path="/appliance-repair-service-in-:area"
          element={<AreaPage />}
        />
        <Route path="/:slug" element={<SlugRouteHandler />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="brands" element={<Brands />} />
          <Route path="orders" element={<Orders />} />
          <Route path="rfq" element={<RFQ />} />
          <Route path="technicians" element={<Technicians />} />
          <Route path="customers" element={<Cutomer />} />
          <Route index element={<Navigate to="dashboard" />} />
        </Route>
      </Routes>

      {!isAdminPage && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}
